var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic4"},[_c('h2',{staticClass:"topic4-h2"},[_vm._v(_vm._s(_vm.$t("做好交易准备了吗？")))]),_c('h5',{staticClass:"topic4-h5"},[_vm._v(" "+_vm._s(_vm.$t("它快速且容易上手。通过我们简单的申请流程，几分钟之内即可申请。"))+" ")]),_c('div',{staticClass:"topic4-btn",on:{"click":_vm.toLogin}},[_vm._v(_vm._s(_vm.$t("开立真实用户")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }